import script from "./FlightPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./FlightPortal.vue?vue&type=script&setup=true&lang=js"

import "./FlightPortal.vue?vue&type=style&index=0&id=0dde9d7c&lang=scss"

const __exports__ = script;

export default __exports__